import script from "./quality.vue?vue&type=script&setup=true&lang=ts"
export * from "./quality.vue?vue&type=script&setup=true&lang=ts"

import "./quality.vue?vue&type=style&index=0&id=53e68f9f&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e68f9f"]])

export default __exports__